import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Handle scroll to toggle background/shadow
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { label: 'The Problem', href: '#problem' },
    { label: 'How It Works', href: '#process' },
    { label: 'Why Lisa', href: '#why' },
    { label: 'Pricing', href: '#pricing' },
  ];

  return (
    <nav
      className={`
        fixed top-0 left-0 right-0 z-50 transition-all duration-500
        ${scrolled ? 'bg-[#F5F0E6] shadow-[0_1px_0_rgba(0,0,0,0.06)]' : 'bg-transparent'}
      `}
    >
      <div className="w-full px-6 lg:px-16 py-5 flex items-center justify-between">
        <a href="#" className="cursor-pointer">
          <span
            className={`
              text-[13px] font-bold tracking-[0.2em] uppercase transition-colors duration-500
              ${scrolled ? 'text-[#2C3E50]' : 'text-white'}
            `}
          >
            Brand Guardian
          </span>
        </a>

        {/* Desktop navigation */}
        <div className="hidden lg:flex items-center gap-10">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`
                text-[13px] font-medium tracking-wide transition-colors duration-300 cursor-pointer hover:opacity-70
                ${scrolled ? 'text-[#2C3E50]' : 'text-white/90'}
              `}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Call‑to‑action and mobile menu toggle */}
        <div className="flex items-center gap-4">
          <a
            href="#contact"
            className={`
              hidden sm:inline-flex items-center px-6 py-2.5 text-[13px] font-semibold rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer
              ${scrolled
                ? 'bg-[#D98C74] text-white hover:bg-[#c47a62]'
                : 'bg-white text-[#2C3E50] hover:bg-white/90'}
            `}
          >
            Protect Your Brand
          </a>

          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`
              lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer
              ${scrolled ? 'text-[#2C3E50]' : 'text-white'}
            `}
            aria-label="Menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-[#F5F0E6] border-t border-[#D98C74]/20 px-6 py-6 space-y-4">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block text-[14px] font-medium text-[#2C3E50] cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="block bg-[#D98C74] text-white text-center py-3 rounded-md text-[14px] font-semibold cursor-pointer whitespace-nowrap"
          >
            Protect Your Brand
          </a>
        </div>
      )}
    </nav>
  );
}
